<div class="d-flex flex-column">
    <div class="d-flex flex-row align-items-center justify-content-between mb-3">
        <h3 class="mb-0 fw-bolder">Admin User Management</h3>
        <div class="d-flex flex-row align-items-center gap-2">
            <div class="d-flex flex-row align-items-center gap-2">
                <input type="text" class="form-control form-control-sm" placeholder="Add Existing User" [(ngModel)]="existing_username">
                <button class="btn btn-primary btn-sm text-nowrap text-truncate" (click)="addExistingUser()">Existing Username</button>
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
                <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'user', 'form', 'new']">Add Admin User</button>
            </div>
        </div>
    </div>
    <table class="table table-bordered table-striped">
        <thead>
            <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Status</th>
                <th class="text-center">Edit</th>
                <th class="text-center">Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of users">
                <td class="align-middle">{{user.name}} 
                    <span class="badge bg-primary" *ngIf="user.is_super_admin">Super Admin</span>
                    <span class="badge bg-warning" *ngIf="user.is_support">Support</span>
                    <span class="badge bg-danger" *ngIf="!user.is_super_admin && !user.is_support && user.created_by_super_admin">Created by Super Admin</span>
                </td>
                <td class="align-middle">{{user.username}}</td>
                <td class="align-middle">{{user.status ? 'Active' : 'Inactive'}}</td>
                <td class="text-center">
                    <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'user', 'form', user.uuid]" [disabled]="user.is_super_admin">Edit</button>
                </td>
                <td class="text-center">
                    <button class="btn btn-danger btn-sm" (click)="deleteUser(user.uuid)" [disabled]="user.is_super_admin">Delete</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>